const allowedShippingList = ["shopup_venipak_shipping_courier_method:5"];
import helpers from "../modules/helpers";

const WoocommerceCheckout = {
  init: function () {
    this.events();
  },

  events: function () {
    document.addEventListener("cab_updated_checkout", () => {
      const country = $("#billing_country").val();

      const sebBankCountryEl = $(
        '[name="seb_commerce_bank[preferred_country]"]'
      );
      if (sebBankCountryEl.length) {
        if (sebBankCountryEl.children(`option[value=${country}]`).length) {
          sebBankCountryEl.val(country);
        }

        jQuery(".preferred-country select, li.payment_method_seb_commerce_bank")
          .trigger("change")
          .change();
      }
    });

    $("body").on(
      "change",
      ".payment_methods input[name=payment_method]",
      (e) => {
        console.log("Payment method changed");
        let method = $(e.currentTarget).val();

        $("#payment-description-box .payment_box").slideUp();
        $(`#payment-description-box .payment_method_${method}`).slideDown();

        jQuery(".preferred-country select, li.payment_method_seb_commerce_bank")
          .trigger("change")
          .change();
      }
    );

    if (!$("#ship-to-different-address-checkbox").is(":checked")) {
      $('.checkout-step[data-step="3"]')
        .find(".required")
        .addClass("not-required");
      $('.checkout-step[data-step="3"]')
        .find(".not-required")
        .removeClass("required");
    }

    $("#ship-to-different-address-checkbox").on("change", function () {
      if ($(this).is(":checked")) {
        $('.checkout-step[data-step="3"]')
          .find(".not-required")
          .addClass("required");
        $('.checkout-step[data-step="3"]')
          .find(".required")
          .removeClass("not-required");
      } else {
        $('.checkout-step[data-step="3"]')
          .find(".required")
          .addClass("not-required");
        $('.checkout-step[data-step="3"]')
          .find(".not-required")
          .removeClass("required");
      }
    });

    // If not logged in
    $(".checkout-next-guest").on("click", function (e) {
      e.preventDefault();

      $(".checkout-login-form").addClass("hidden");
      WoocommerceCheckout.goToStep(1, "next");
    });

    // Next step.
    $(".checkout-next").on("click", function (e) {
      if (e.target.classList.contains("payment__submit-btn")) {
        return;
      }

      e.preventDefault();

      const btnEl = $(this);
      const stepNum = btnEl.closest(".checkout-step").data("step");
      const currStepEl = $('.checkout-step[data-step="' + stepNum + '"]');
      // Save user data
      WoocommerceCheckout.userInfo();

      // Validate Step
      if (helpers.validate(currStepEl)) {
        $(".errors-wrap").remove();
        WoocommerceCheckout.goToStep(stepNum, "next");
      }
    });

    // Nav navigation
    $(".checkout-nav-link").on("click", function (e) {
      e.preventDefault();

      var btn = $(this);
      var currStep = $(".checkout-nav-link--active").data("step");

      if (btn.data("step") < currStep) {
        WoocommerceCheckout.goToStep(btn.data("step"));
      }
    });

    // Shipping method
    $("body").on("change", "shipping_method", function () {
      let shippingMethod = $(".shipping_method:checked");

      if (!allowedShippingList.includes(shippingMethod.val())) {
        $("#ship-to-different-address-checkbox").prop("checked", false);
      }
    });

    // On checkout update.
    $("body").on("update_checkout", function () {
      $("form.checkout").addClass("loading");
    });

    // On updated checkout.
    $("body").on("updated_checkout", function () {
      WoocommerceCheckout.handleShippingForm();
      WoocommerceCheckout.handleUserType();
      WoocommerceCheckout.fixShippingForm();
      WoocommerceCheckout.fixShippingOptions();

      $("form.checkout").removeClass("loading");
    });

    // On checkout error
    $("body").on("checkout_error", function () {
      WoocommerceCheckout.scrollToCheckout();

      $("form.checkout").removeClass("loading");
    });

    // On user change
    $("body").on("change", 'input[name="billing_person"]', function () {
      WoocommerceCheckout.handleUserType();
    });

    // On submit
    $("body").on("click", "#place_order", function () {
      $(".woocommerce-checkout").addClass("loading");
    });
  },

  customerData() {
    $("#customerInfo").html("");
    const customerData = {
      ["Name, surname"]:
        $('input[name="billing_first_name"]').val() +
        " " +
        $('input[name="billing_last_name"]').val(),
      ["Country"]: $('select[name="billing_country"]').val(),
      ["City"]: $('input[name="billing_city"]').val(),
      ["Street address"]: $('input[name="billing_address_1"]').val(),
      ["House / Apartments nr."]: $('input[name="billing_address_2"]').val(),
      ["Postal code"]: $('input[name="billing_postcode"]').val(),
      ["Phone number"]: $('input[name="billing_phone"]').val(),
      ["E-mail"]: $('input[name="billing_email"]').val(),
    };
    Object.entries(customerData).forEach((item) => {
      if (item[1] !== "") {
        $("#customerInfo")
          .append(`<li class="account-info__item account-dashboard__info-item order-details-customer__item">
					<span class="order-details-customer__item-name">${item[0]}</span>
					<span class="order-details-customer__item-value">${
            item[1] !== "" ? item[1] : " "
          }</span>
				</li>`);
      }
    });
  },

  shippingData() {
    $("#shippingInfo").html("");

    let deliveryMethod = $("#shipping_method")
      .find("input:checked")
      .parent()
      .find("label")
      .html();

    const shippingData = {
      ["Delivery method"]: deliveryMethod,
      ["Country"]: $('select[name="billing_country"]').val(),
      ["City"]: $('input[name="billing_city"]').val(),
      ["Street address"]: $('input[name="billing_address_1"]').val(),
      ["House / Apartments nr."]: $('input[name="billing_address_2"]').val(),
      ["Postal code"]: $('input[name="billing_postcode"]').val(),
      // ['Shipping cost'] : $('input[name="billing_phone"]').val(),
    };
    Object.entries(shippingData).forEach((item) => {
      if (item[1] !== "") {
        $("#shippingInfo")
          .append(`<li class="account-info__item account-dashboard__info-item order-details-customer__item">
					<span class="order-details-customer__item-name">${item[0]}</span>
					<span class="order-details-customer__item-value">${
            item[1] !== "" ? item[1] : " "
          }</span>
				</li>`);
      }
    });
  },

  scrollToCheckout: function () {
    $("html, body").animate(
      {
        scrollTop: $(".checkout-nav").offset().top - 100,
      },
      500
    );
  },

  /**
   * Shows or hidens shipping form
   */
  handleShippingForm: function () {
    let shippingMethod = $(".shipping_method:checked");

    const shippingForm = $(".woocommerce-shipping-fields");

    if (allowedShippingList.includes(shippingMethod.val())) {
      // show
      shippingForm.show();
    } else {
      shippingForm.hide();
    }
  },

  /**
   * Handle step change
   */
  goToStep: function (step, action) {
    if (typeof step == undefined) {
      return false;
    }

    if (typeof action == undefined) {
      action = "current";
    }

    //
    var target;
    switch (action) {
      case "next":
        if (step <= $(".checkout-step").length) {
          target = step + 1;
        } else {
          target = step;
        }
        break;

      case "prev":
        if (step > 1) {
          target = step - 1;
        } else {
          target = step;
        }
        break;

      default:
        target = step;
        break;
    }

    // Fix nav
    WoocommerceCheckout.navState(target);

    // Step transition
    $(".checkout-step").removeClass("current").addClass("hidden");
    $('.checkout-step[data-step="' + target + '"]')
      .removeClass("hidden")
      .addClass("current");

    $(".errors-wrap").remove();

    WoocommerceCheckout.scrollToCheckout();
    WoocommerceCheckout.customerData();
    WoocommerceCheckout.shippingData();
  },

  /**
   * Handles nav state
   */
  navState: function (step) {
    $('.checkout-nav .checkout-nav-link[data-step="' + step + '"]')
      .parent()
      .prevAll()
      .children()
      .addClass("checkout-nav-link--passed");
    $('.checkout-nav .checkout-nav-link[data-step="' + step + '"]')
      .parent()
      .nextAll()
      .children()
      .removeClass("checkout-nav-link--passed");
    $('.checkout-nav .checkout-nav-link[data-step="' + step + '"]').addClass(
      "checkout-nav-link--active"
    );
    $('.checkout-nav .checkout-nav-link[data-step="' + step + '"]')
      .parent()
      .siblings()
      .children()
      .removeClass("checkout-nav-link--active");
  },

  /**
   * Handle user type
   */
  handleUserType: function () {
    // const legalBox = $('input[name="billing_person"]:checked');

    // // Set current type
    // if (legalBox.val() === "legal") {
    //   activeType = "legal";
    //   disabledType = "private";
    // } else {
    //   activeType = "private";
    //   disabledType = "legal";
    // }
    const disabledType = "legal";
    const activeType = "private";

    WoocommerceCheckout.billingFieldOrder(activeType);

    // Show/hide fields
    $(".form-row.type-" + disabledType)
      .hide()
      .find("input")
      .addClass("disabled");
    $(".form-row.type-" + activeType)
      .show()
      .find("input")
      .removeClass("disabled");
  },

  /**
   * Order billing fields
   */
  billingFieldOrder: function (type) {
    const fieldOrder = {
      private: [
        "first_name",
        "last_name",
        "address_1",
        "city",
        "postcode",
        "country",
        "phone",
        "email",
      ],
      legal: [
        "company",
        "reg_nr",
        "pvn",
        "address_1",
        "city",
        "postcode",
        "country",
        "first_name",
        "last_name",
        "phone",
        "email",
      ],
    };
    fieldOrder[type].forEach((id, index) => {
      $(`#billing_${id}_field`).css({
        order: index,
      });
    });
  },

  /**
   * Generate user info
   */
  userInfo: function () {
    $(".cab-billing-info").html("");
    $(".cab-shipping-info").html("");

    const legalBox = $('input[name="billing_person"]:checked');

    let disabledType;

    if (legalBox.attr("id") === "person-legal") {
      disabledType = "private";
    } else {
      disabledType = "legal";
    }

    $(
      ".woocommerce-billing-fields .form-row:not(.type-" +
        disabledType +
        "):not(.type-select) input"
    ).each(function () {
      var input = $(this);
      var val = input.val();
      var label = input.parent().prev().text();

      var label = label.replace("*", "");
      if (val) {
        $(".cab-billing-info").append(
          '<li class="info-box__item">' + val + "</li>"
        );
      }
    });

    // Shipping info
    let output = [];
    let shipping = $(
      '.woocommerce-shipping-totals input[type="radio"]:checked'
    );

    output.push(shipping.next().html());

    // Add selected omniva parcel
    if ("omnivalt_pt" == shipping.val()) {
      output.push($(".terminal-container .dropdown").text());
    }

    // Add shipping address
    if ("shopup_venipak_shipping_courier_method:5" == shipping.val()) {
      if ($("#ship-to-different-address-checkbox").prop("checked")) {
        $(".shipping_address input").each(function () {
          output.push($(this).val());
        });
      } else {
        $(".woocommerce-billing-fields .address-field input").each(function () {
          output.push($(this).val());
        });
      }
    }

    output.forEach((item) => {
      $(".cab-shipping-info").append(
        '<li class="info-box__item">' + item + "</li>"
      );
    });
  },

  /**
   * Fix shipping options
   */
  fixShippingOptions: function () {
    $("#shipping_method input").each(function () {
      var input = $(this);
      let id = input.attr("id");

      if (input.prop("checked")) {
        // Omniva
        if (id && id.includes("omnivalt_pt")) {
          input.siblings(".terminal-container").removeClass("hidden");
          input
            .siblings(".terminal-container")
            .find("select")
            .addClass("required");
          // Hide pay in store
          $(".payment_method_payinstore").hide();
        }
      } else {
        // Omniva
        if (id && id.includes("omnivalt_pt")) {
          $(".terminal-container").addClass("hidden");
          $(".terminal-container").find("select").removeClass("required");
        }
      }
    });
  },

  /**
   * Handles Shipping form
   */
  fixShippingForm: function () {
    const inputEl = $("#ship-to-different-address-checkbox");

    const sfcol = $(".shipping_address");

    if (inputEl.prop("checked")) {
      sfcol.show();
      sfcol.find("input.required").removeClass("disabled");
    } else {
      sfcol.hide();
      sfcol.find("input.required").addClass("disabled");
      WoocommerceCheckout.copyBillingToShipping();
    }
  },

  /**
   * Copies billing form data to shipping form
   */
  copyBillingToShipping: function () {
    $(
      ".woocommerce-billing-fields input, .woocommerce-billing-fields select"
    ).each(function () {
      let input = $(this);
      let target = "#" + input.attr("id").replace("billing_", "shipping_");

      $(".woocommerce-shipping-fields").find(target).val(input.val());
    });
  },
};
export default WoocommerceCheckout;
